import { AdminPagesStateModel } from "../../admin.state";
import { DeptCode } from "../models/dept-code.model";

export class DeptCodesStateModel extends AdminPagesStateModel {
  items: DeptCode[];
}